import store from '@/store';
import { findCountryRegionByCode, findRegions } from './regionFinder';
import { QuoteAddress } from '@/store/models';
import { i18n } from '@/i18n';

const API_KEY = store.state.options.gmap.api_key;
const LIBRARIES = 'places';

let initialized = !!window.google;
let resolveProm: any;
let rejectProm: any;

window.gmapAutocompleteElement = {};
window.gmapAutocomplete = {};
window.gmapAutocompleteListener = {};

const promise: any = new Promise((resolve, reject) => {
    resolveProm = resolve;
    rejectProm = reject;
});

export default function init(): Promise<typeof google> {
    if (initialized) {
        return promise;
    }

    initialized = true;
    window.gmapsCallback = () => resolveProm(window.google);
    window.gm_authFailure = () => {
        for (const p in window.gmapAutocomplete) {
            if (window.gmapAutocomplete.hasOwnProperty(p)) {
                window.gmapAutocomplete[p].unbindAll();
                google.maps.event.clearInstanceListeners(window.gmapAutocompleteElement[p]);
                window.gmapAutocompleteElement[p].disabled = false;
                window.gmapAutocompleteElement[p].style = '';
                window.gmapAutocompleteElement[p].placeholder = i18n.t('Street').toString();
            }
        }
    };
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&callback=gmapsCallback&libraries=${LIBRARIES}`;
    script.onerror = rejectProm;
    const headEl = document.querySelector('head') as HTMLElement;
    headEl.appendChild(script);

    return promise;
}

export function calculateDistance(lon1: number, lat1: number, lon2: number, lat2: number) {
    const R = 6371;
    const lat1Rad = lat1 * Math.PI / 180;
    const lat2Rad = lat2 * Math.PI / 180;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1Rad)
        * Math.cos(lat2Rad) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return d;
}

export function placeFoundCallback(place: google.maps.places.PlaceResult, address: QuoteAddress) {
    if (place.address_components && place.address_components.length > 0) {
        const coutryRegions = findRegions(address.country_id);
        const multicarrier = store.state.options.carrier.multicarrier;
        const street = {
            number: '',
            address: '',
        };
        // place.address_components.forEach((addressComponent) => {
        //   const addressType = addressComponent.types[0];
        //   if (addressType === 'country') {
        //     address.country_id = addressComponent.short_name;
        //   }
        // });
        place.address_components.forEach((addressComponent) => {
            const addressType = addressComponent.types[0];
            switch (addressType) {
                case 'locality':
                    address.city = addressComponent.long_name;
                    break;
                case 'street_number':
                    street.number = addressComponent.long_name;
                    break;
                case 'route':
                    street.address = addressComponent.long_name;
                    break;
                case 'postal_code':
                    if (!multicarrier) {
                        address.postcode = addressComponent.long_name;
                    }
                    break;
                case 'administrative_area_level_2':
                    if (address.country_id && addressComponent.short_name) {
                        const regionFound = findCountryRegionByCode(address.country_id, addressComponent.short_name);
                        if (regionFound && regionFound.region_id) {
                            address.region_id = regionFound.region_id;
                        } else {
                            if (!coutryRegions) {
                                address.region = addressComponent.long_name;
                            }
                        }
                    }
                    break;
            }
        });

        if (street.address) {
            address.street = [street.address];
            const found = address.custom_attributes ?
                address.custom_attributes.find((att: any) => att.attribute_code === 'tdy_street_number') : false;
            if (found) {
              found.value = street.number;
            }
        }
    }
    return address;
}
